import React from 'react'

// GraphQL
import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      resetCartForm, // via redux actions
      onWaiversQueryCompleted, // via withWaiverForms
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const { loading, data } = useQuery(query, {
      onError: onQueryError,
      onCompleted: data => {
        if (!onLoggedInQueryCompleted(data)) {
          return
        }

        const { viewer: account, sessions } = data
        const { cart, campers } = account
        resetCartForm({ cart, campers, sessions })
        onWaiversQueryCompleted(data)
      }
    })

    // GraphQL data
    const { viewer: account, seasons, sessions, appConfig } = data || {}
    const season = seasons ? seasons[0] : null
    const { enableCovidRequirements } = appConfig || {}

    return (
      <WrappedComponent
        loading={loading}
        account={account}
        season={season}
        sessions={sessions || []}
        enableCovidRequirements={enableCovidRequirements}
        {...props}
      />
    )
  }
}

export default withQuery
